import React, {Component, Fragment} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Card, Popconfirm, Divider, Drawer, message, Button} from "antd";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import PackingSlipDetail from "./packingSlipDetail";
import * as api from "../../api/packingSlip";
import PackingPreview from "./packingPreview";
import * as config from "../report-order/config";
import FormModal from "../../components/FormModal";


const PrintFragment = authWrapper('print')(Fragment);
const DeliveryFragment = authWrapper('delivery')(Fragment);
const DeletePopconfirm = authWrapper('delete')(Popconfirm);

class PackingSlip extends Component {

    columns = [
        {
            title: '送货单号',
            dataIndex: 'packing_no'
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: (status) => ({
                0: '未发货',
                1: '已发货'
            }[status])
        },
        {
            title: '创建日期',
            dataIndex: 'created_time'
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                    <Fragment>
                        <a onClick={() => this.onDetailModalShow(record)}>明细</a>
                        <Divider type={'vertical'}/>
                    </Fragment>
                    <PrintFragment>
                                <a onClick={() => this.onPrint(record)}>打印</a>
                                <Divider type={'vertical'}/>
                    </PrintFragment>
                    {record.status !== 1 && (
                        <Fragment>
                            <DeliveryFragment>
                                <Popconfirm title={'是否确认发货'} onConfirm={() => this.onDelivery(record.id)}>
                                    <a>发货</a>
                                </Popconfirm>
                                <Divider type={'vertical'}/>
                            </DeliveryFragment>
                            <DeletePopconfirm title={'是否确认删除'} onConfirm={() => this.onDelete(record.id)}>
                                <a>删除</a>
                            </DeletePopconfirm>
                        </Fragment>
                    )}
                </span>
            )
        }
    ]

    state = {
        selectedRecord: null,

        detailModalVisible: false,

        modalPreviewVisible: false,
        modalPreviewRecords: [],
        modalPreviewOrder: {},
        modalPreviewLoading: false,

        importModalVisible: false,
        importModalSaving: false,
        importModalFile: null,
    }

    handleUploadModalOK = () => {
        this.setState({
            importModalSaving: true
        });
        api.importDetail(this.state.importModalFile).then(response => {
            this.setState({
                importModalSaving: false,
                importModalVisible: false,
            });
            this.dataTable.fetch();
        }).catch(() => {
            this.setState({
                importModalSaving: false
            });
        })
    }

    onDetailModalShow = (record) => {
        this.setState({
            selectedRecord: record,
            detailModalVisible: true
        })
    }

    onPrint = (record) => {
        this.setState({modalPreviewLoading: true})
        api.detailPacking(record.id).then(({data}) => {
            this.setState({
                modalPreviewVisible: true,
                modalPreviewLoading: false,
                modalPreviewRecords: data.data,
                modalPreviewOrder: record
            })
        }).catch(() => {
            this.setState({modalPreviewLoading: false})
        })
    }

    onDelete = (packingId) => {
        api.deletePacking(packingId).then(() => {
            this.dataTable.fetch()
        })
    }

    onDelivery = (packingId) => {
        api.deliveryPacking(packingId).then(() => {
            this.dataTable.fetch();
            message.success('发货成功');
        })
    }

    render() {
        return (
            <PageHeaderLayout title={'送货单'}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <Button type={'primary'} onClick={() => this.setState({importModalVisible: true})}>导入</Button>

                    </div>
                    <StandardTable url={'/api/packing/slip/'}
                                   columns={this.columns}
                                   ref={table => this.dataTable = table}
                    />
                </Card>
                <Drawer visible={this.state.detailModalVisible}
                        onClose={() => this.setState({detailModalVisible: false})}
                        width={1000}
                >
                    <PackingSlipDetail record={this.state.selectedRecord}/>
                </Drawer>
                <PackingPreview visible={this.state.modalPreviewVisible}
                                width={1300}
                                order={this.state.modalPreviewOrder}
                                records={this.state.modalPreviewRecords}
                                onCancel={() => this.setState({modalPreviewVisible: false})}
                />
                <FormModal visible={this.state.importModalVisible}
                           fields={config.importReconciliationModalFields((file) => this.setState({importModalFile: file}))}
                           onCancel={() => this.setState({importModalVisible: false})}
                           onOk={this.handleUploadModalOK}
                           confirmLoading={this.state.importModalSaving}
                />
            </PageHeaderLayout>
        );
    }
}

export default PackingSlip;
